import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { ICardsState } from '../ICardState';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import CardStateHelper from '../CardStateHelper';

export const REMOVE_THREE_CARDS_AMOUNT = 3;

const illegalModifierTypes: CardModifierType[] = [
    CardModifierType.rope,
];

export function removeThreePreBoosterFilterCb(cardsState: ICardsState, cardID: string): boolean {
    const behavior = CardStateHelper.getCardBehavior(cardsState, cardID);
    const hasIllegalModifiers = CardStateHelper.getModifiersOfType(cardsState, cardID, ...illegalModifierTypes).length > 0;

    return (
        !hasIllegalModifiers &&
        !behavior.isBlocked(cardsState) &&
        behavior.getCardType(cardsState) === CardType.value
    );
}
